import { Component, OnInit, ViewEncapsulation } from '@angular/core';

/** @deprecated - This component should not be used */
@Component({
    selector: 'sb-modal-body',
    template: `
        <main #modalBody class="sb-modal-body">
            <ng-content></ng-content>
        </main>
    `,
    styles: [
        `
            // shame
            sb-modal-body {
                .pills[role='tablist'] {
                    margin-top: 0;
                }
            }
        `
    ],
    standalone: true,
    encapsulation: ViewEncapsulation.None
})
export class SbModalBodyComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
